import { TeePublic } from 'core/globals'
import { Application } from '@hotwired/stimulus';
import Password from '../core/controllers/inputs/password_controller'
import SignIn from '../core/controllers/sign_in_controller'
import Validators from 'shared/validators'

// Stimulus Application Setup
const application = Application.start(document.documentElement);

application.register("inputs--password", Password);
application.register("sign-in", SignIn);

TeePublic.Validators = Validators;
